__turbopack_context__.v({
  "aiPosting": "ClubProfilePage-module-scss-module__rKpFRq__aiPosting",
  "cardOverlay": "ClubProfilePage-module-scss-module__rKpFRq__cardOverlay",
  "content": "ClubProfilePage-module-scss-module__rKpFRq__content",
  "heroArea": "ClubProfilePage-module-scss-module__rKpFRq__heroArea",
  "loading": "ClubProfilePage-module-scss-module__rKpFRq__loading",
  "moderationNotice": "ClubProfilePage-module-scss-module__rKpFRq__moderationNotice",
  "notifications": "ClubProfilePage-module-scss-module__rKpFRq__notifications",
  "notificationsTitle": "ClubProfilePage-module-scss-module__rKpFRq__notificationsTitle",
  "page": "ClubProfilePage-module-scss-module__rKpFRq__page",
  "tabsWrapper": "ClubProfilePage-module-scss-module__rKpFRq__tabsWrapper",
});
